export default {
  /**邀请返佣首页 start */
  inviToReback: "邀请返佣",
  accumuRewrds: "我已获得累计奖励",
  completedTranscation: "好友完成1手以上永续合约交易，即可获得10USDT额外奖励",
  inviteQuick: "虚位以待，快点行动起来吧～",
  currWeekRank: "本周排行",
  weekRank: "榜单排名",
  inviteNum: "邀请人数",
  rebackAmount: "返佣金额",
  checkAllRanks: "查看完整榜单",
  rebackRegu: "奖励规则",
  rebaRegu1:
    "好友首充后，您可在60天内享受好友交易25%的手续费返佣，注：单个好友最多返佣500USDT，多推多拿，无上限。",
  rebaRegu2: "二重奖励：好友交易1手BTC永续合约后，您可获得10USDT额外奖励。",
  shareOnce: "一键分享",
  myBill: "我的海报",
  shareToFace: "面对面邀请",
  myShareQrCode: "我的邀请二维码",
  sharOnceTitle: "好友{phone}发来邀请",
  sharOnceText: "邀请您注册BTCC可获得5USDT赠金活动",
  shareActiveRegu: "活动规则",
  shareActiveTime: "活动时间：长期有效 活动对象：真实用户；",
  shareActiveSpire: "奖励计算有效期：被邀请人激活60天内；",
  shareActiveReward:
    "交易返利：奖励计算有效期内，被邀请人完成开户并激活交易，推荐人即可获得对应的交易返USDT；",
  shareActiveTip: "注：邀请1个好友交易返利上限500USDT，多推多拿，无上限。",
  shareActiveAtten: "注意事项：",
  shareAtiveRegu1:
    "被推荐人必须通过推荐人的个人推荐链接（或二维码）完成开户，否则将不视为有效推荐，即无法享受客户交易赠金，真实用户才能生成个人推荐链接（或二维码）；",
  shareAtiveRegu2: "交易手数计算：被推荐人激活后60天内的所有平仓手数；",
  shareAtiveRegu3:
    "返利以自然日计算，将在每个工作日(周一至周五)进行发放，如遇假期将顺延；",
  shareAtiveRegu4: "当平台活动与邀请返佣产生冲突时，请视平台其他活动规则优先；",
  shareAtiveRegu5:
    "BTCC保留本条款的最终解释权，及随时修改或终止本优惠的权利，而无须事先作出通知。",
  /**邀请返佣首页 end */

  /**邀请记录，返佣记录 start */
  inviteReocrd: "邀请记录",
  rebackRecord: "返佣记录",
  invitedAccount: "邀请人账号",
  inviteTime: "邀请时间",
  status: "状态",
  checkMore: "查看更多",
  noRecord: "查无记录！",
  type: "类型",
  rebaNum: "返佣数",
  activited: "已激活",
  notActive: "未激活",
  /**邀请记录，返佣记录 end */
  /**排行榜 start */
  rankList: "排行榜",
  yourCurrWeekData: "，您本周数据",
  billboard: "排名榜",
  phone: "手机号",
  cumulateReback: "累计返佣",
  noData: "暂无数据",
  /**排行榜 end */
  /**账户等级 start */
  account: "账户，",
  accountLevel: "账户等级",
  miniAccount: "迷你账户",
  stdAccount: "标准账户",
  vipAccount: "VIP账户",
  stdFeeCut: "手续费降6.66%",
  vipFeeCut: "手续费狂降20%",
  currYouAre: "您当前是",
  min: "迷你账户",
  std: "标准账户",
  dia: "VIP账户",
  superValueReco: "超值推荐",
  invest: "充值（{unit}）",
  upgradeQuick: "立即升级",
  moreGradeProfit: "后期将陆续开放更多账户等级权益，敬请期待",
  konwAccountLevel: "了解账户等级",
  whatsAccountLevel: "什么是账户等级",
  thisIsAccountLevel:
    "请根据您累计充值的USDT，主动联系客服进行账户升级；充值越多，账户等级越高，可享受的手续费越低，交易成本越低，更多权益正快马加鞭赶来。",
  whichAccountLevel: "有哪些账户等级",
  accountLevelTypes: "BTCC账户等级分为迷你、标准、VIP三种",
  accountLevCondiAndProfit: "账户等级条件与权益",
  feeRate: "费率",
  level: "等级",
  deposit: "存款",
  profit: "权益",
  mini: "迷你",
  noRights: "无特权",
  standard: "标准",
  stdFeeCuts: "费率直降6.66%",
  vipFeeCuts: "费率狂降20%",
  moreCutToFees: "具体费率减免见资金费率",
  example: "举例",
  exampleDetail:
    "“以现价BTC/USDT8000USDT 计算手续费，用户累计交易50手BTC/USDT永续合约为例”",
  noRecharge: "(无优惠)",
  cut40: "(直降40USDT)",
  cut120: "(狂降120USDT)",
  minGradeAtten: "立即升级可享受更多权益！",
  stdGradeAtten: "继续升级可享受更多权益！",
  diaGradeAtten: "立即交易享受更多优惠吧！",
  /**账户等级 end */

  /**账户升级start */
  appliUpgrade: "申请升级",
  accountNumber: "账户号码",
  upgradeTo: "升级成为",
  submit: "提交",
  upgradeNeedKnow: "账户升级须知：",
  upgradeNeedKnow1: "1.升级前请确保您所选择需要升级的账户里没有持仓与挂单；",
  upgradeNeedKnow2: "2.客服会于您申请后的下一个工作日中午前审批处理；",
  upgradeNeedKnow3: "3.审批后，您只需重新登录即可享受更佳的投资体验。",
  accountUpgrade: "账户升级",
  applyPno: "申请提交成功！（申请编号：{pno}）",
  applyNumber: "阁下的BTCC账户号码：",
  applyFrom: "申请从",
  applyTo: "账户升级为",
  applyResTime: "客服会于您申请后的下一个工作日中午前审批处理。",
  /**账户升级end */

  accountNoDot: "账户",
  bonus: "赠金",
  cashBack: "返利",

  // 邀请返佣
  inviteHasInvitedUser: "已邀请用户",
  inviteCumulativeBack: "累计返佣(USDT)",
  inviteFriend: "邀请好友",
  inviteFriendDesc:
    "随我一起加入BTCC并每日抽出免费赠金！BTCC福利中心高达1BTC奖励等你拿。填写我的推荐码来注册吧！",
  inviteMyInviteLink: "我的邀请链接：",
  inviteShareLink: "分享链接",
  inviteCode: "邀请码：",
  inviteCopy: "复制",
  inviteNow: "立即邀请",
  inviteToUser: "邀请用户",
  inviteMyReward: "我的返佣",
  inviteUser: "用户",
  inviteRegisterTime: "注册时间",
  inviteNoInvitePerson: "暂无被邀请的人,",
  inviteStartInvite: "开始邀请",
  inviteReward: "返佣（USDT）",
  inviteQRDesc: "注册BTCC 最高可领取 500USDT赠金",
  inviteQRJoin: "扫一扫加入",
  inviteCopySuccess: "复制成功",
  inviteCopyError: "复制失败",
  inviteFriendWin: "邀请好友轻松赚取",
  inviteWinPercent: "25%",
  inviteBack: "佣金",
  inviteNoRecord: "暂无记录",
  inviteSlogan: "推荐好友完成交易，将可获得高达<strong>500USDT</strong>现金",
  "您当前VIP等级,享受手续费折扣":
    "当前等级：<span class='{level}'></span> 享受 <strong>{current}</strong> VIP费率折扣 继续升级享受 <strong>{next}</strong> 折扣",
  VIP交易费率: "VIP交易费率",
  VIP等级: "VIP等级",
  账户资金: "总资产净值",
  合约交易手续费: "合约交易手续费",
  币币交易手续费: "币币交易手续费",
  前往充值: "立即前往充值升级VIP",
  前往充币:"立即前往充币",
  充提币手续费: "充提币手续费",
  币种: "币种",
  充币费用: "充币费用",
  提币费用: "提币费用",
  最小提币数量: "最小提币数量",
  最小充币数量: "最小充币数量",
  折扣: "{amount} 折扣",
  说明: "条款及细则：",
  说明1: "BTCC VIP采用自动升级机制，系统将根据VIP等级规则，自动处理VIP的升级。以下为不同VIP等级的更新时间：",
  说明2: "新版VIP系统中，用戶一旦升級便不再降級。",
  说明3: "每一笔的开仓/平仓手续费都将根据用户当前所处的VIP等级进行收取。",
  说明4: "BTCC不分吃单费率与挂单费率。",
  说明5: "*以上规则已于2023年1月10日 15:00（UTC+8）开始生效。",
  vip权益全面升级: "权益全面升级",
  生效时间: "生效时间：2022/04/25 00:00:00 (UTC+8)",
  其他货币: "其他货币",

  // 累计充值活动
  新手专享: "新手专享",
  注册成功后等级赠金奖励:
    "注册成功后{day}天内完成充值目标，即享相应等级赠金奖励",
  前往福利中心参与其他活动: "前往活动中心参与其他热门活动",
  不符合新手报名条件: "不符合新手活动条件",
  新手专享豪礼送: "新手专享豪礼送！",
  如何领取奖励: "如何领取奖励",
  如何领取奖励第一步: "第一步：注册或登录",
  如何领取奖励第二步: "第二步：达到储值金额",
  如何领取奖励第三步: "第三步：自动发放赠金奖励",
  储值福利进度: "{coin}充值福利进度",
  充值升级下一级:
    "您已获得<strong>{bonus}</strong>赠金，再累计充值<strong>{amount}</strong>，解锁下一级奖励！",
  充值升级提示:
    "注册成功后{day}天内进行更多充值，可在活动期间赚取高达17,500USDT赠金奖励",
  立即报名: "登录参与活动",
  有效充值: "有效充值",
  累计返利: "累计返利(USDT) ",
  我的赠金记录: "我的赠金记录",
  福利中心: "福利中心",
  活动举例: "活动举例",
  活动规则及条款: "活动规则及条款",
  活动版权: "本次活动最终解释权归BTCC所有。如有任何疑问，",
  请联系客服: "请联系客服",
  报名成功: "报名成功",
  充币提示:
    "您可以选择任何一种的币种进行充值，点击币种进行查看您的该币种充值进度。",
  我已了解: "我已了解",
  // 活动共享
  立即充币: "立即充币",
  立即买币: "快捷买币",
  立即登录: "立即登录",
  免费注册: "免费注册",
  "参与活动": "参与活动",
  "立即参与": "立即参与",
  "继续充值": "继续充值",
  captcha_desc: "向右拖动滑块填充拼图",
  当前等级: "当前等级:",
  当前: "",
  参数: "参数",
  兑换手续费减免: "兑换手续费减免",
  提币手续费减免: "提币手续费减免",
  月总成交量USD: "30日总成交量(USD)",
  账户资产USD: "账户资产(USD)",
  账户资产: "账户资产",
  继续升级: "继续升级享受{amount}折扣",
  gotIt: "明白了",
  我的30日成交量: "我的30日成交量",
  最近30天成交的交易合约: "最近30天成交的交易合约，以USD计算",
  我的资产: "我的资产",
  昨日账户资产: "昨日账户资产（包含所有币种）的价值，以USD计算<span>*每天00:00 (UTC+8)更新</span>",
  "title": "10日交易挑战",
  "solgen": "做任务开盲盒！最高领取210USDT赠金及交易手续费全免！",
  "super": "超级大盲盒！",
  "super_award": "随机${min}-{max}USDT赠金",
  "supper_task": "领取任意7个盲盒后可领取",
  "supper_tip": "需要先完成每日任务领取7个盲盒哦",
  "supper_open": "拆盲盒",
  "day": "挑戰進度：第{day}天",
  "award_fee": "随机{min}%-{max}%合约手续费返现",
  "award_bouns": "随机${min}-${max}USDT赠金",
  "task_complete": "已完成<span>{reach}/{total}</span>笔交易",
  "contract_task": "合约任务",
  "task_need": "完成任意<span>{num}</span>笔交易",
  "get_award_fee": "已领取：{amount}%手续费返现",
  "get_award_bouns": "已领取：${amount}USDT赠金",
  "award_overdue": "已过期",
  "award_hasget": "已领取",
  "award_toget": "待领取",
  "task_nostart": "未开始",
  "task_ongoing": "进行中",
  "task_rules": "活动规则",
  "task_rules_content1": "1. 参与条件：2022/12/20 16:062022/12/23 10:00:00 (UTC+8) 后的VIP0用户。VIP0用户只需在此活动上线后升级至VIP1或以上的等级便会自动参与此活动。",
  "task_rules_content1_desc": "2022/12/20 16:062022/12/23 10:00:00 (UTC+8) 前已经从VIP0升级到VIP1-9的用户无法参与此活动。",
  "task_rules_content2":  "2. 當用戶升级至VIP1或以上後，活動便會立即開始。此活动頁的資訊於每日5:00AM （UTC+8）更新。",
  "task_rules_content3":  "3. 必须完成当日交易任务才能开启该日盲盒奖励。在当日结算时间前未完成当天交易任务即失效。当天结算时间后自动重置交易笔数，并自动开启下一天的交易任务；",
  "task_rules_content4":  "4. 盲盒共计两种奖励形式，手续费返现及USDT赠金。手续费返现为现金奖励，领取后将自动发放至账户余额中，现金可交易可提取。赠金仅能用作合约交易时产生的手续费用抵扣，将根据不同的VIP等级进行一定比例的抵扣；",
  "task_rules_content5": "5. 手续费返现奖励只会返现当天计算在活动中的交易笔数，超出当天任务的交易笔数不会进行返现；",
  "task_rules_content6":  "6. 大盲盒开启条件为必须先完成任意7天的交易任务并开启7个盲盒，如在活动结束前未满足条件则无法开启大盲盒；",
  "task_rules_content7":  "7. 盲盒奖励存在随机性和概率性；",
  "task_rules_content8":  "8. 盲盒奖励实时到账。如果奖励沒有及時到帳，請联系客服查询；",
  "task_rules_content9":  "9. 如您的账号在活动期间被限制或判定为异常状态，您将无法开启盲盒；",
  "task_rules_content10":  "10. 交易包含开仓、平仓及强平；交易产品包括所有USDT合约及币本位合约；交易笔数统计交易的次数。",
  "task_rules_content11":  "其他条款",
  "task_rules_content12":  "1. 活动期间，如有恶意刷量行为、批量注册小号、自买自卖、相互对敲等作弊行为，BTCC将保留立即取消任何表现出欺诈行为迹象的参与者参与自个的权利；",
  "task_rules_content13":  "2.BTCC保留自行决定取消或修改活动或活动规则的权利，无需事先通知；",
  "task_rules_content14":  "3. BTCC保留对本次活动的最终解释权。如有疑问，请联系客服。",
  "complete_task": "成功完成<span>{num}</span>个交易",
  "no_standard": "完成{num}个交易，未达标"
};



// WEBPACK FOOTER //
// ./src/locales/zh-CN.js